import { z } from "zod";

export const formSchema = z.object({
  firstName: z.string().min(1, "Nama depan wajib diisi"),
  lastName: z.string().min(1, "Nama belakang wajib diisi"),
  phone: z.string().min(10, "Nomor HP minimal 10 digit").max(15, "Nomor HP maksimal 15 digit"),
  email: z.string().email("Email tidak valid"),
  address: z.string().min(5, "Alamat minimal 5 karakter"),
  source: z.string().min(1, "Sumber informasi wajib dipilih"),
  orderStatus: z.enum(["Customer Baru", "Repeat Order", "Lainnya"], {
    message: "Status pemesanan wajib dipilih",
  }),
  willAttend: z.enum(["Ya", "Tidak"], {
    message: "Pilih salah satu opsi",
  }),
  vehicleBrand: z.string().min(1, "Merek mobil wajib diisi"),
  vehicleModel: z.string().min(1, "Jenis mobil wajib diisi"),
  vehicleYear: z.number().min(1980, "Tahun minimal 1980").max(new Date().getFullYear(), `Tahun maksimal ${new Date().getFullYear()}`),
  vehiclePlate: z.string().min(1, "Plat mobil wajib diisi"),
  vehicleColor: z.string().min(1, "Warna mobil wajib diisi"),
  serviceCity: z.enum(["Jogja", "Solo", "Semarang", "Bandung", "Surabaya"], {
    message: "Kota layanan wajib dipilih",
  }),
  vehicleLocation: z.string().min(5, "Lokasi mobil wajib diisi (minimal 5 karakter)"),
  inspectionDate: z.string().min(1, "Tanggal inspeksi wajib diisi"),
  inspectionTime: z.string().min(1, "Jam inspeksi wajib diisi"),
  notes: z.string().optional(),
  ownerContact: z.string().optional(),
});

export type FormData = z.infer<typeof formSchema>;
